
const artefactCategories = [
    {
      title: 'Машины',
      items: [
        {
          name: 'BMW 8',
          description: 'This vast mountain range is renowned for its remarkable mountain range',
          image: '/img/bmw.png',
          link: 'bmw-8',
          text: 'This vast mountain range is renowned for its remarkable diversity in terms of topography and climate. It features towering peaks, active volcanoes, deep canyons, expansive plateaus, and lush valleys. The Andes are also home to this vast mountain range is renowned for its remarkable diversity in terms of topography and climate.',
        },
        {
          name: 'Cadillac',
          description: 'This vast mountain range is renowned for its remarkable mountain range',
          image: '/img/cadillac.png',
          link: 'cadillac',
          text: 'This vast mountain range is renowned for its remarkable diversity in terms of topography and climate. It features towering peaks, active volcanoes, deep canyons, expansive plateaus, and lush valleys. The Andes are also home to this vast mountain range is renowned for its remarkable diversity in terms of topography and climate.',
        },
      ],
    },
    {
      title: 'Мотоциклы',
      items: [
        {
          name: 'BMW 8',
          description: 'This vast mountain range is renowned for its remarkable mountain range',
          image: '/img/bmw.png',
          link: 'moto-bmw-8',
          text: 'This vast mountain range is renowned for its remarkable diversity in terms of topography and climate. It features towering peaks, active volcanoes, deep canyons, expansive plateaus, and lush valleys. The Andes are also home to this vast mountain range is renowned for its remarkable diversity in terms of topography and climate.',
        },
        {
          name: 'Cadillac',
          description: 'This vast mountain range is renowned for its remarkable mountain range',
          image: '/img/cadillac.png',
          link: 'moto-cadillac',
          text: 'This vast mountain range is renowned for its remarkable diversity in terms of topography and climate. It features towering peaks, active volcanoes, deep canyons, expansive plateaus, and lush valleys. The Andes are also home to this vast mountain range is renowned for its remarkable diversity in terms of topography and climate.',
        },
      ],
    },
  ];

  export default artefactCategories